export default __webpack_public_path__ + "images/operator.svg";